// extracted by mini-css-extract-plugin
export var circle = "_3o-2";
export var icon = "_3o-a";
export var iconHighlight = "_3o-0";
export var lg = "_3o-8";
export var md = "_3o-7";
export var outline = "_3o-4";
export var sm = "_3o-6";
export var square = "_3o-1";
export var xl = "_3o-9";
export var xs = "_3o-5";
export var xxs = "_3o-3";